type Line = Record<string, any>;
type Result = Record<string, any>;

const LINE_HEADERS = [
  "Tab", "Usecase", "Account Number", "Journal Side", "Company Code", "Location",
  "Cost Center", "Product Line", "Channel", "Project", "Functional Amount",
  "Local Amount", "Currency", "GL Line Description", "Set of Books", "Match Key",
  "Environment", "Classification", "Passed",
];

const DISCREPANCY_HEADERS = [
  "Tab", "Field", "Usecase", "Gamma Value", "Prod Value", "Account Number",
  "Classification", "Passed",
];

const MATCH_SET_HEADERS = [
  "Tab", "Environment", "Match Key", "Account Number", "Amount", "Currency",
  "Closed", "Classification", "Passed",
];

function esc(value: unknown): string {
  const s = String(value ?? "");
  return s.includes(",") || s.includes('"') || s.includes("\n")
    ? `"${s.replace(/"/g, '""')}"` : s;
}

function lineRow(tab: string, l: Line): string {
  return [
    tab, l.usecase, l.accountNumber, l.journalSide, l.companyCode, l.location,
    l.costCenter, l.productLine, l.channel, l.project, l.functionalAmount,
    l.localAmount, l.currency, l.glLineDescription, l.setOfBooks, l.matchKey,
    l.environment, l.classification, l.passed,
  ].map(esc).join(",");
}

export function downloadShadowTestCsv(result: Result): void {
  const rows: string[] = [];

  const lineGroups: [string, Line[] | undefined][] = [
    ["Matched", result.matchedLines],
    ["Gamma Unique", result.gammaUniqueLines],
    ["Prod Unique", result.prodUniqueLines],
    ["JEM Unique", result.jemUniqueLines],
  ];

  if (lineGroups.some(([, lines]) => lines?.length)) {
    rows.push(LINE_HEADERS.join(","));
    for (const [tab, lines] of lineGroups) {
      lines?.forEach(l => rows.push(lineRow(tab, l)));
    }
  }

  if (result.discrepancies?.length) {
    if (rows.length) rows.push("");
    rows.push(DISCREPANCY_HEADERS.join(","));
    result.discrepancies.forEach((d: Line) =>
      rows.push([
        "Discrepancies", d.field, d.usecase, d.gammaValue, d.prodValue,
        d.accountNumber, d.classification, d.passed,
      ].map(esc).join(","))
    );
  }

  if (result.matchSets?.length) {
    if (rows.length) rows.push("");
    rows.push(MATCH_SET_HEADERS.join(","));
    result.matchSets.forEach((m: Line) =>
      rows.push([
        "Match Sets", m.environment, m.matchKey, m.accountNumber, m.amount,
        m.currency, m.closed, m.classification, m.passed,
      ].map(esc).join(","))
    );
  }

  const blob = new Blob([rows.join("\n")], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `shadow-test-${result.transactionId || "result"}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
